module.exports = __webpack_public_path__ + "img/clouds.d1a1d8b4.png";